export default "__VITE_ASSET__GiqCvz0z__"